// Screen `engagements` (owner: engagements): every meeting, e-mail, call and note of the workspace as data: table,
// board and calendar with typed filters and saved views.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import type { FilterNode } from '@dataroom/core';
import { EngagementsPage } from '../../../features/engagements/page/EngagementsPage';
import { ModuleGate } from '../../../shell/ModuleGate';

export const Route = createFileRoute('/_app/engagements/')({
  validateSearch: z.object({
    layout: z.enum(['table', 'board', 'calendar']).optional().catch(undefined),
    v: z.string().max(80).optional().catch(undefined),
    // The filter as the router writes it: a filter node (null = deliberately none), else the view's own.
    f: z.custom<FilterNode | null>().optional().catch(undefined),
    // The words of the search box (title, text, people).
    q: z.string().max(200).optional().catch(undefined),
    group: z.string().max(63).optional().catch(undefined),
    sort: z.string().max(80).optional().catch(undefined),
    cols: z.string().max(1200).optional().catch(undefined),
    tgroup: z.string().max(63).optional().catch(undefined),
    month: z.string().max(7).optional().catch(undefined),
    open: z.uuid().optional().catch(undefined),
  }),
  component: function EngagementsRoute() {
    const search = Route.useSearch();
    return (
      <ModuleGate module="activities">
        <EngagementsPage search={search} />
      </ModuleGate>
    );
  },
});
